define('flight-components/Listing',['require','flight/lib/component','flight-components/mixins/withListings'],function (require) {

  var component = require('flight/lib/component');
  var withListings = require('flight-components/mixins/withListings');

  return component(Listing, withListings);

  function Listing() {

    this.defaultAttrs({
      listingSelector: '.listing'
    });

    this.after('initialize', function () {

    });
    
  }
});

